import React from 'react';
import { Calendar } from '@/components/Icons/Calendar';
import { Radio } from '@/components/Radio';
import { tv } from '@/utils/tv';

const card = tv({
  base: 'flex min-w-0 flex-1 cursor-pointer items-center gap-3 rounded-xl bg-popover text-left shadow-card',
  variants: {
    hasIcon: {
      true: 'px-4 py-3',
      false: 'p-4',
    },
  },
});

interface Props {
  title: string;
  subtitle?: string;
  hasIcon?: boolean;
  isSelected: boolean;
  onSelect: () => void;
}

export const RatingsOptionCard: React.FC<Props> = ({
  title,
  subtitle,
  hasIcon = false,
  isSelected,
  onSelect,
}) => (
  <button type="button" onClick={onSelect} className={card({ hasIcon })}>
    {hasIcon && (
      <span className="flex items-center justify-center rounded-full bg-info-surface p-2 text-primary">
        <Calendar className="size-4" />
      </span>
    )}
    <div className="flex min-w-0 flex-1 flex-col gap-0.5">
      <p className="text-subhead-14 truncate text-foreground">{title}</p>
      {subtitle && (
        <p className="text-body-13 truncate text-muted-foreground md:text-caption-12">
          {subtitle}
        </p>
      )}
    </div>
    <Radio checked={isSelected} />
  </button>
);
